import React from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';
import { AkamaiAccountProvider } from '@bnnvara/accounts';
import { FacebookProvider } from '@bnnvara/embeds';
import { GoogleOptimizeProvider } from '@bnnvara/google-optimize';
import { SterBannerProvider } from '@bnnvara/ster';
import { BookmarkProvider } from '../../components/Bookmark/BookmarkProvider';
import { FollowBrandProvider } from '../../components/FollowBrand/FollowBrandProvider';
import FingerprintProvider from '../FingerprintProvider/FingerprintProvider';
import { NotificationsProvider } from '../../hooks/notifications';
import { RefContextProvider } from '../../hooks/useSharedRef';
import { UIContextProvider } from '../../hooks/useUI';

const { publicRuntimeConfig } = getConfig();

const BaseProvider = ({ children }) => (
  <RefContextProvider>
    <FingerprintProvider>
      <GoogleOptimizeProvider>
        <FacebookProvider appId={publicRuntimeConfig.facebook.appId} wait>
          <SterBannerProvider>
            <UIContextProvider>
              <AkamaiAccountProvider config={publicRuntimeConfig.akamai}>
                <FollowBrandProvider>
                  <BookmarkProvider>
                    <NotificationsProvider>{children}</NotificationsProvider>
                  </BookmarkProvider>
                </FollowBrandProvider>
              </AkamaiAccountProvider>
            </UIContextProvider>
          </SterBannerProvider>
        </FacebookProvider>
      </GoogleOptimizeProvider>
    </FingerprintProvider>
  </RefContextProvider>
);

BaseProvider.propTypes = {
  children: PropTypes.node,
};

export default BaseProvider;
